module.exports = __webpack_public_path__ + "static/media/Shelmet_gaussian2.050592f4.png";